export default {
  autoUpdate: 'Update automatically (every {0})',
  updateInterval: 'Update interval',
  lastUpdate: 'Last update',
  nextUpdate: 'Next update in {0}',
};
